import React from "react";
import "../../Assets/Styles/Style.css";
const UserInfo = ({ data }) => (
  <>
    <div className="group-info-row">
      <div className="info-label">Name</div>
      <div className="info-value-below">{data.user_info.full_name}</div>
    </div>
    <div className="group-info-row">
      <div className="info-label">Phone No</div>
      <div className="info-value-below">{data.user_info.phone_no}</div>
    </div>
    <div className="group-info-row">
      <div className="info-label">Address:</div>
      <div className="info-value-below">{data.personal_info?.address || "N/A"}</div>
    </div>
  </>
);

export default UserInfo;
